import React, { useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { useSnackbar } from 'notistack'
import { Route, Switch } from 'react-router-dom'

import Loader from './Components/Loader'
import { setEnqueueSnackbar } from './lib/snackbar'
import MainRouter from './MainRouter'

const useStyles = makeStyles({
  app: {
    height: '100vh',
    width: '100vw',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  content: {
    display: 'flex',
    overflow: 'hidden',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: '2%',
    marginBottom: 'auto'
  },
}, { name: 'App' })

function App(props) {
  const classes = useStyles(props)
  const { enqueueSnackbar } = useSnackbar()

  useEffect(() => {
    setEnqueueSnackbar(enqueueSnackbar)
  }, [enqueueSnackbar])

  return (
    <div className={classes.app}>
      <Switch>
        <Route path="/">
          <div className={classes.content}>
            <MainRouter />
          </div>
        </Route>
      </Switch>
      <Loader />
    </div>
  )
}

export default (App)
